import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Button, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { url } from '../../constants/routes';
import { connect } from '../../reducers/index';
import './styles.css';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
// import IARBanner from './img/main-hero-02.svg';
import IARGraphic from './img/IAR-123-graphic.svg';
import MHModal from '../../components/MentalModal';


class ModulePage extends React.Component {
  constructor(props) {
    super(props);

    this.scrollClick = this.scrollClick.bind(this);
  }

  scrollClick(e) {
    e.preventDefault();
    const contentElement = document.getElementById("content");
    contentElement.scrollIntoView();
  }

  render() {

    return (

      <div className="education-module">
        <Helmet>
          <title>Welcome to Education Module</title>
        </Helmet>
        <Navigation role={this.props.role} />
        <div className="home-banner">
          {/* <img
            className="home-img"
            src={IARBanner}
            alt="1 woman with binnoculars , 2 man holding sign that says Help is Available and, 3 woman pointing to sign that says Help is this way and also Help is this way"
          /> */}
          <div className="image-hero">

          </div>
          <a className="scroll-down" aria-label="Scroll down to content"
            onClick={(e) => { this.scrollClick(e) }}
          />
        </div>

        <section className="no-padd">
          <div id="maincontent" className="container intro">
            <Row className="text-center">
              <Col xs={10} xsOffset={1}>
                <img
                  className="img-block img-fluid"
                  style={{ margin: '2em auto 1em auto' }}
                  src={IARGraphic}
                  alt="1 Identify, 2 Assist, 3 Refer, steps of the education module"
                />
              </Col>
            </Row>
          </div>
        </section>
        <section id="content">
          <div className="container">
            <Row>
              <Col xs={10} xsOffset={1}>
                <h1 style={{ marginTop: '1em', textAlign: 'center' }}>
                  Welcome to <span className="txt-purple">Identify</span>,&nbsp;
                  <span className="txt-green">Assist</span> and&nbsp;
                  <span className="txt-dkblue">Refer</span>.
                </h1>
                <p>
                  The “Identify, Assist, Refer” approach provides you with the basic skills and
                  information needed to support people experiencing mental health challenges,
                  whether or not they live with a mental illness.
                </p>
                <p>
                  Before we start, it’s important to know that mental health doesn’t always equate to mental illness.
                 <span style={{ fontWeight: "bold" }}> Mental health</span> is the capacity of each and every one of
                 us to feel, think, and act in ways that enhance our ability to enjoy life and deal with the everyday
                 challenges we face. <span style={{ fontWeight: "bold" }}>Mental illness</span>, on the other hand,
                 refers to changes in thinking, mood, and behaviour that are associated with significant distress and
                 impaired functioning (Public Health Agency of Canada, 2016). Mental health is something that we all
                 recognize in ourselves and others whereas diagnosis of a mental illness is done by health professionals.
                 Our mental health exists along a continuum from flourishing to languishing, and is separate and distinct
                 from mental illness. One can have mental illness and be quite productive in their lives and similarly,
                 someone with absence of mental illness can experience poor mental health. Please take a moment to explore
                 the <span style={{ fontWeight: "bold" }}>Dual Continuum Model of Mental Health and Mental Illness </span>
                 presented below to see how this continuum is described by Corey Keyes. Click on the plus tab for more
                 information on this model.
                </p>

              </Col>
              <Col xs={10} xsOffset={1} className="relative">
                <MHModal />
              </Col>
              <Col xs={10} xsOffset={1} md={6} mdOffset={3} className="text-center extra-margin"
              >
                <small>Reference for photo: MacKean, 2011.</small>
                <br />
                <small>
                  Adapted from: The Health Communication Unit at the Dalla Lana School of Public Health at the
                  University of Toronto and Canadian Mental Health Association, Ontario; based on the conceptual work of
                  Corey Keyes.
                </small>
              </Col>
              <Col xs={10} xsOffset={1}>
                <p style={{ fontSize: 12 }}>
                  Canadian Association of College & University Student Services and Canadian Mental Health Association. (2013). <br />
                  <div style={{ marginLeft: 90 }}>
                    Post-Secondary student mental health: Guide to a systemic approach. Healthy Minds | Healthy Campuses.
                    <a
                      href="https://healthycampuses.ca/wp-content/uploads/2014/09/The-National-Guide.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://healthycampuses.ca/wp-content/uploads/2014/09/The-National-Guide.pdf
                    </a>.
                  </div>
                </p>
                <br />
                <p style={{ fontSize: 12 }}>
                  Public Health Agency of Canada. (2016, July 07).<br />
                  <div style={{ marginLeft: 90 }}>
                    Mental health and wellness. Canadian Best Practices Portal.
                    <a
                      href="https://cbpp-pcpe.phac-aspc.gc.ca/public-health-topics/mental-health-and-wellness/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://cbpp-pcpe.phac-aspc.gc.ca/public-health-topics/mental-health-and-wellness/
                    </a>.
                  </div>
                </p>
              </Col>
              <Col xs={10} xsOffset={1}>
                <p className="text-center">
                  <LinkContainer
                    to={url.PRE_QUESTIONNAIRE}
                    className="btn next btn-blue"
                  >
                    <Button>Next</Button>
                  </LinkContainer>
                </p>
              </Col>
            </Row>
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}

ModulePage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const Module = ModulePage;

export default connect.role(Module);



// WEBPACK FOOTER //
// ./src/containers/Module/index.jsx